export const GET_LOCATION_DETAILS = 'GET_LOCATION_DETAILS'

export const CLEAR_LOCATION_DETAILS = 'CLEAR_LOCATION_DETAILS' 